import React from "react";
import JsonData from "../data/data.json";
import { Contact } from "./contact";
import { SITE_URL } from "./Seo";

// Pflichtangaben einer GmbH nach § 5 DDG. Beide Werte stammen aus dem
// Registerauszug bzw. vom Finanzamt und müssen mit dem Google-Unternehmens-
// profil übereinstimmen – Google gleicht Firmendaten zwischen Website und
// Profil ab. Die USt-IdNr. steht zusätzlich als "vatID" im LocalBusiness-
// Schema in public/index.html; beide Stellen zusammen pflegen.
// Leere Werte blenden den jeweiligen Abschnitt aus (eine falsche Angabe ist
// rechtlich schlechter als eine fehlende).
// ---------------------------------------------------------------------------
const HANDELSREGISTER = "HRB 18602";
const UST_ID = "DE340555039";

// Registergericht laut Registerauszug – nicht aus dem Firmensitz ableiten,
// der Sitz im Register kann von der Geschäftsadresse abweichen.
const REGISTERGERICHT = "Amtsgericht Fürth";

const FIRMA = "Merdovic Trockenbau GmbH";

// Aus data.json statt doppelt gepflegt: Adresse, Telefon und E-Mail müssen
// hier identisch zu Kontaktbereich, Schema und Google-Unternehmensprofil
// stehen, sonst ordnet Google die Signale nicht derselben Firma zu.
const { address, phone, email } = JsonData.Contact;
const [street, city] = address.split(", ");

export const Impressum = () => {
    return (
        <div id="impressum">
            <div className="container">
                <div className="section-title impressum text-center">
                    <h1>Impressum</h1>
                </div>

                <div className="row">
                    <div className="col-md-8 col-md-offset-2 text-center">
                        <h4>Angaben gemäß § 5 DDG</h4>
                        <p>{FIRMA}<br />
                            Marko Merdovic<br />
                            {street}<br />
                            {city}
                        </p>

                        <h4>Vertreten durch</h4>
                        <p>Marko Merdovic</p>

                        <h4>Kontakt</h4>
                        <p>
                            {`Telefon: ${phone}`}<br />
                            {`E-Mail: ${email}`}<br />
                            {`Website: ${SITE_URL.replace("https://", "")}`}
                        </p>

                        {UST_ID && (
                            <>
                                <h4>Umsatzsteuer-ID</h4>
                                <p>
                                    Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                                    {UST_ID}
                                </p>
                            </>
                        )}

                        {HANDELSREGISTER && (
                            <>
                                <h4>Handelsregister</h4>
                                <p>{`${FIRMA}, ${HANDELSREGISTER}, ${REGISTERGERICHT}`}</p>
                            </>
                        )}

                        <h4>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h4>
                        <p>
                            Marko Merdovic<br />
                            {street}<br />
                            {city}
                        </p>

                        <hr />

                        <h4>Haftung für Inhalte</h4>
                        <p>
                            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                            Nach §§ 8 bis 10 DDG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
                            oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
                            Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                            Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                        </p>

                        <h4>Haftung für Links</h4>
                        <p>
                            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
                            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                        </p>

                        <h4>Urheberrecht</h4>
                        <p>
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
                            Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                            bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
                            Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
                            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                        </p>
                    </div>
                </div>
            </div>
            <Contact data={JsonData.Contact} />

        </div>
    );
};
